import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/shared/components'
import { TariffCardPage } from '@/pages/tariffs/TariffCardPage'

export const Route = createFileRoute('/tariffs/$tariffId')({
  component: () => (
    <RequirePermission section="tariffs" action="view_card">
      <TariffCardPage />
    </RequirePermission>
  ),
})
